import * as React from "react";
import styles from "./QouteLines01Grp.module.css";

function QouteLines01Grp() {
  return (
    <section>
    <figure className={styles.quoteContainer}>
      <div className={styles.quoteWrapper}>
        <div className={styles.quoteBackground}>
          <div className={styles.decorativeElements}></div>
          <blockquote className={styles.quoteTextWrapper}>
            <p className={styles.quoteText}>
              <span>design</span>
              <span className={styles.redCircle} aria-hidden="true" /> 
           
              <span> code</span>
              <span className={styles.greenCircle} aria-hidden="true" />{" "}
              innovate & repeat
            </p>
            <span className={styles.blueCircle} aria-hidden="true" />
          </blockquote>
        </div>
      </div>
    </figure>
    </section>
  );
}

export default QouteLines01Grp;
